import { Range } from "@archipad-js/core/range";

import { Expression } from "./predicate";

/**
 * Returns an {@link Expression expression} which evaluates to `true` if the
 * given field value is within the given range.
 *
 * @example
 * ```
 * const expression = makeRangeExpression({
 *      fieldName: "value",
 *      range: {
 *          lower: { bound: 1, open: true },
 *          upper: { bound: 2, open: true },
 *      },
 * });
 * ```
 */
export function makeRangeExpression(options: { fieldName: string; range: Range<unknown> }): Expression {
    const { fieldName, range } = options;
    let expression = Expression.true;

    if (range.lower) {
        if ("including" in range.lower) {
            const [key, value] = Object.entries(range.lower.including).at(0) as [string, unknown];
            expression = expression.and(Expression.parse(`${fieldName} >= {${key}}`, { [key]: value }));
        } else {
            const [key, value] = Object.entries(range.lower.excluding).at(0) as [string, unknown];
            expression = expression.and(Expression.parse(`${fieldName} > {${key}}`, { [key]: value }));
        }
    }

    if (range.upper) {
        if ("including" in range.upper) {
            const [key, value] = Object.entries(range.upper.including).at(0) as [string, unknown];
            expression = expression.and(Expression.parse(`${fieldName} <= {${key}}`, { [key]: value }));
        } else {
            const [key, value] = Object.entries(range.upper.excluding).at(0) as [string, unknown];
            expression = expression.and(Expression.parse(`${fieldName} < {${key}}`, { [key]: value }));
        }
    }

    return expression;
}
